// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"K--z","disabled":"L--z","label":"M--z"};